import React, { useState, useRef, useEffect } from 'react';
import { ArrowRightIcon, ArrowDownTrayIcon, CheckCircleIcon, PencilSquareIcon, EllipsisVerticalIcon, XCircleIcon } from '@heroicons/react/24/solid';

const TripActionsMenu = ({ trip, onEdit, onStateUpdate, onDownloadDocs }) => {

  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    const clickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', clickOutside);
    return () => document.removeEventListener('mousedown', clickOutside);
  }, []);

  return (
    <div className="relative" ref={ref}>
      <button
        onClick={() => setOpen(!open)}
        className="p-1 rounded-full hover:bg-gray-100"
      >
        <EllipsisVerticalIcon className="w-5 h-5 text-gray-600" />
      </button>

      {open && (
        <div className="absolute right-0 mt-2 bg-white border rounded shadow-md z-50 w-44">
          <button
            onClick={() => {
              setOpen(false);
              onEdit();
            }}
            className="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap"
          >
            <PencilSquareIcon className="w-4 h-4 mr-2 text-blue-600" />
            {["completed", "cancelled"].includes(trip.status) ? "View" : "Edit"}
          </button>
          { ["created"].includes(trip.status) &&
            <button
              onClick={() => {
                setOpen(false);
                onStateUpdate(trip, "ongoing");
              }}
              className="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap"
            >
              <ArrowRightIcon className="w-4 h-4 mr-2 text-blue-600" />
              Mark as Ongoing
            </button>
          }
          { ["ongoing"].includes(trip.status) &&
            <button
              onClick={() => {
                setOpen(false);
                onStateUpdate(trip, "completed");
              }}
              className="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap"
            >
              <CheckCircleIcon className="w-5 h-5 mr-2 text-green-600" />
              Complete Trip
            </button>
          }
          { ["created"].includes(trip.status) &&
            <button
              onClick={() => {
                setOpen(false);
                onStateUpdate(trip, "cancelled");
              }}
              className="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap"
            >
              <XCircleIcon className="w-4 h-4 mr-2 text-red-600" />
              Cancel Trip
            </button>
          }
          <button
            onClick={() => {
              setOpen(false);
              onDownloadDocs(trip);
            }}
            className="flex items-center w-full px-4 py-2 hover:bg-gray-100 text-sm whitespace-nowrap"
          >
            <ArrowDownTrayIcon className="w-4 h-4 mr-2 text-indigo-600" />
            Download Docs
          </button>
        </div>
      )}
    </div>
  );
};

export default TripActionsMenu;
